import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "jquery-ui/themes/base/all.css";
import "jquery-ui/ui/widgets/autocomplete";
import { cx } from "@emotion/css";
import axios from "axios";
import $ from "jquery";
import { parseUrl } from "query-string";
import { useEffect, useRef, useState } from "react";
import { dnbComLog, getParameterByName, isNotUndefinedOrNull, isUndefinedOrNull, lazyLoadScriptMarketo, LogSeverity } from "../FunctionsCore";
import { useUTMQueryParamsPersistence } from "../hooks";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import MarketoFormStyles from "./MarketoFormStyles.module.scss";
const styles = MarketoFormStyles;
const classCombiner = classCombinerFromPrefix("73b8326001a38992");
const gLltCampaignValueName = "gLLTCampaign";
const gLltContentValueName = "gLLTContent";
const gLltMediumValueName = "gLLTMedium";
const gLltSourceValueName = "gLLTSource";
const utmCampaignValueName = "utm_campaign__c";
const utmContentValueName = "utm_content__c";
const utmMediumValueName = "utm_medium__c";
const utmSourceValueName = "utm_source__c";
const gaCidValueName = "gACid";
const gaTidValueName = "gATID";
const gaUidValueName = "gAUID";
const gLDunsNumber = "gLDUNSNumber";
const gL3rdpartyCustomernumber = "gL3rdpartyCustomernumber";
const bisnodeIsoCodeArray = new Set(["AT", "BA", "CH", "CZ", "DE", "DK", "EE", "FI", "GB", "HR", "HU", "LV", "NO", "PL", "RS", "SE", "SI", "SK"]);
const MarketoFormComponent = (props) => {
    const { additionalText, componentclass, continueToSecondStepOfTwoStepFormButtonText, dunsNumber, formDescription, heading, isoCode, marketoFormIdInt, marketourl, munchkinid, privacyPolicyLink, privacyPolicyText, termsOfUseLink, termsOfUseText, thankYouPageLink, useTwoStepFormBoolean } = props;
    const reference = useRef(null);
    const [isFirstStepActive, setIsFirstStepActive] = useState(true);
    const isBisnode = isNotUndefinedOrNull(isoCode) && bisnodeIsoCodeArray.has(isoCode);
    const { getParameterValue } = useUTMQueryParamsPersistence();
    useEffect(() => {
        lazyLoadScriptMarketo(marketourl).addRunAfterScriptLoadCallback((mktoFormsTwo) => {
            let dunsBisnod = "";
            mktoFormsTwo.loadForm(marketourl, munchkinid, marketoFormIdInt, (marketoForm) => {
                if (isUndefinedOrNull(marketoForm)) {
                    dnbComLog(LogSeverity.ERROR, "marketoForm is undefined or null", marketourl, munchkinid, marketoFormIdInt);
                }
                else {
                    const $refCurrent = $(reference.current);
                    marketoForm.render($refCurrent);
                    $refCurrent
                        .find("style")
                        .remove();
                    const $referenceCurrentAndDescendants = $refCurrent.find("*").addBack();
                    $referenceCurrentAndDescendants.each((_, ht) => ht.removeAttribute("style"));
                    marketoForm.onSubmit((onSubmitMarketoForm) => {
                        // Start of Bisnode only
                        if (isBisnode) {
                            try {
                                const hrefParsed = parseUrl(window.location.href);
                                const { query } = hrefParsed;
                                let gLLTSource = getParameterByName(gLltSourceValueName);
                                if (gLLTSource === "") {
                                    gLLTSource = getParameterValue(gLltSourceValueName);
                                    if (gLLTSource === "") {
                                        gLLTSource = query["utm_source"];
                                        if (isUndefinedOrNull(gLLTSource) || gLLTSource === "") {
                                            gLLTSource = getParameterValue("utm_source");
                                        }
                                    }
                                }
                                let gLLTMedium = getParameterByName(gLltMediumValueName);
                                if (gLLTMedium === "") {
                                    gLLTMedium = getParameterValue(gLltMediumValueName);
                                    if (gLLTMedium === "") {
                                        gLLTMedium = query["utm_medium"];
                                        if (isUndefinedOrNull(gLLTMedium) || gLLTMedium === "") {
                                            gLLTMedium = getParameterValue("utm_medium");
                                        }
                                    }
                                }
                                let gLLTContent = getParameterByName(gLltContentValueName);
                                if (gLLTContent === "") {
                                    gLLTContent = getParameterValue(gLltContentValueName);
                                    if (gLLTContent === "") {
                                        gLLTContent = query["utm_content"];
                                        if (isUndefinedOrNull(gLLTContent) || gLLTContent === "") {
                                            gLLTContent = getParameterValue("utm_content");
                                        }
                                    }
                                }
                                let gLLTCampaign = getParameterByName(gLltCampaignValueName);
                                if (gLLTCampaign === "") {
                                    gLLTCampaign = getParameterValue(gLltCampaignValueName);
                                    if (gLLTCampaign === "") {
                                        gLLTCampaign = query["utm_campaign"];
                                        if (isUndefinedOrNull(gLLTCampaign) || gLLTCampaign === "") {
                                            gLLTCampaign = getParameterValue("utm_campaign");
                                        }
                                    }
                                }
                                // TODO Abstract Google Analytics
                                const windowGa = window["ga"];
                                const windowGaGetAll = windowGa === null || windowGa === void 0 ? void 0 : windowGa.getAll();
                                const windowGaGetAllFirstElement = windowGaGetAll === null || windowGaGetAll === void 0 ? void 0 : windowGaGetAll[0];
                                const clientId = windowGaGetAllFirstElement === null || windowGaGetAllFirstElement === void 0 ? void 0 : windowGaGetAllFirstElement.get("clientId");
                                const trackingId = windowGaGetAllFirstElement === null || windowGaGetAllFirstElement === void 0 ? void 0 : windowGaGetAllFirstElement.get("trackingId");
                                const userId = windowGaGetAllFirstElement === null || windowGaGetAllFirstElement === void 0 ? void 0 : windowGaGetAllFirstElement.get("userId");
                                const gLltCampaign = gLLTCampaign;
                                const gLltContent = gLLTContent;
                                const gLltMedium = gLLTMedium;
                                const gLltSource = gLLTSource;
                                const gaCid = clientId;
                                const gaTid = trackingId;
                                const gaUid = userId;
                                onSubmitMarketoForm.addHiddenFields({
                                    [gL3rdpartyCustomernumber]: dunsNumber,
                                    [gLDunsNumber]: dunsBisnod,
                                    [gLltCampaignValueName]: gLltCampaign,
                                    [gLltContentValueName]: gLltContent,
                                    [gLltMediumValueName]: gLltMedium,
                                    [gLltSourceValueName]: gLltSource,
                                    [gaCidValueName]: gaCid,
                                    [gaTidValueName]: gaTid,
                                    [gaUidValueName]: gaUid,
                                    [utmCampaignValueName]: gLltCampaign,
                                    [utmContentValueName]: gLltContent,
                                    [utmMediumValueName]: gLltMedium,
                                    [utmSourceValueName]: gLltSource,
                                });
                            }
                            catch (er) {
                                dnbComLog(LogSeverity.ERROR, "Error occurred while trying to add hidden fields", er);
                            }
                        }
                        // End of Bisnode only
                        dnbComLog(LogSeverity.INFO, "MktoForms2 onSubmit fired");
                    });
                    marketoForm.onValidate((validationSucceeded) => {
                        dnbComLog(LogSeverity.INFO, "MktoForms2 onValidate fired");
                        if (validationSucceeded === true) {
                            dnbComLog(LogSeverity.INFO, "MktoForms2 onValidate callback was called with the boolean value true (validation succeeded)");
                        }
                        else if (validationSucceeded === false) {
                            dnbComLog(LogSeverity.ERROR, new Error("MktoForms2 onValidate callback was called with the boolean value false (validation failed)"));
                        }
                        else {
                            dnbComLog(LogSeverity.WARN, new Error(`MktoForms2 onValidate callback was called with an argument of an unexpected type: ${typeof validationSucceeded}`));
                        }
                    });
                    marketoForm.onSuccess((valuesSubmitted, _followUpPageUrl) => {
                        dnbComLog(LogSeverity.INFO, "MktoForms2 onSuccess fired");
                        // Bisnode only
                        if (isBisnode) {
                            // TODO Abstract pushing to "dataLayer"
                            try {
                                const windowDataLayer = window["dataLayer"];
                                let windowDataLayerToUse;
                                if (isUndefinedOrNull(windowDataLayer)) {
                                    windowDataLayerToUse = [];
                                    window["dataLayer"] = windowDataLayerToUse;
                                }
                                else {
                                    windowDataLayerToUse = windowDataLayer;
                                }
                                const keysToSubmitToGoogleAnalytics = [
                                    gaCidValueName,
                                    gaTidValueName,
                                    gaUidValueName,
                                    gLltCampaignValueName,
                                    gLltContentValueName,
                                    gLltMediumValueName,
                                    gLltSourceValueName,
                                    utmCampaignValueName,
                                    utmContentValueName,
                                    utmMediumValueName,
                                    utmSourceValueName
                                ];
                                const formData = {};
                                if (isNotUndefinedOrNull(valuesSubmitted)) {
                                    for (const st of keysToSubmitToGoogleAnalytics) {
                                        const valueToAdd = valuesSubmitted[st];
                                        if (isUndefinedOrNull(valueToAdd)) {
                                            dnbComLog(LogSeverity.WARN, '"valueToAdd" is null or undefined');
                                        }
                                        formData[st] = valueToAdd;
                                    }
                                    const formGroupId = valuesSubmitted["formGroupID"];
                                    if (isUndefinedOrNull(formGroupId)) {
                                        dnbComLog(LogSeverity.WARN, '"formGroupId" is null or undefined');
                                    }
                                    formData["groupId"] = formGroupId;
                                    formData["id"] = formGroupId;
                                }
                                else {
                                    dnbComLog(LogSeverity.WARN, '"valuesSubmitted" is undefined or null, cannot add data to "formData"');
                                }
                                windowDataLayerToUse.push({
                                    "event": "formSubmit",
                                    "formData": formData,
                                });
                            }
                            catch (er) {
                                dnbComLog(LogSeverity.ERROR, 'Error occurred while pushing "formSubmit" event to "dataLayer"', er);
                            }
                        }
                        if (isNotUndefinedOrNull(thankYouPageLink) && thankYouPageLink.length > 0) {
                            window.location.href = `${thankYouPageLink}`;
                        }
                        return false;
                    });
                    // #region Special logic for adding company name autocomplete (Bisnode only)
                    if (isBisnode) {
                        const $selectNameCountryId = $refCurrent.find('select[name="countryId"]');
                        let countryId;
                        countryId = window.String($selectNameCountryId.val());
                        $selectNameCountryId.on("change", (ch) => {
                            const targetAny = ch.target;
                            const targetHtmlInputElement = targetAny;
                            countryId = targetHtmlInputElement.value;
                        });
                        const $inputNameCompany = $refCurrent.find('input[name="Company"]');
                        const inputNameCompanyLength = $inputNameCompany.length;
                        if (inputNameCompanyLength === 1) {
                            $inputNameCompany
                                .autocomplete({
                                "minLength": 3,
                                "select": function (_, ui) {
                                    dunsBisnod = ui.item.primaryNameDuns.duns;
                                    $(this).val(ui.item.primaryNameDuns.primaryName);
                                    return false;
                                },
                                "source": (request, response) => {
                                    axios
                                        .get("/apps/dnb/thirdparty/dnbdirectutil", {
                                        "params": {
                                            "countryISOAlpha2Code": countryId,
                                            "encrypt": false,
                                            "searchTerm": request.term,
                                        }
                                    })
                                        .then((ax) => {
                                        const data = ax.data;
                                        response(data.searchCandidates);
                                    });
                                },
                            })
                                .data("ui-autocomplete")
                                ._renderItem = function (ul, item) {
                                // eslint-disable-next-line react/no-this-in-sfc
                                const term = this.term;
                                const organization = item.organization;
                                const addressLocality = organization.primaryAddress.addressLocality.name;
                                const primaryName = organization.primaryName;
                                const primaryNameDunsSelected = {
                                    "duns": organization.duns,
                                    "primaryName": organization.primaryName
                                };
                                const termEscaped = $.ui.autocomplete.escapeRegex(term);
                                const primaryNameDisplay = primaryName.replace(new RegExp(`(?![^&;]+;)(?!<[^<>]*)(${termEscaped})(?![^<>]*>)(?![^&;]+;)`, "gi"), "<strong>$1</strong>");
                                return ul
                                    .append($("<li></li>")
                                    .data("ui-autocomplete-item", { "primaryNameDuns": primaryNameDunsSelected })
                                    .append(`
<span class="${cx(classCombiner(styles, "autocompleteItem"))}">
    ${primaryNameDisplay} — ${addressLocality}
</span>
`));
                            };
                        }
                        else if (inputNameCompanyLength > 1) {
                            throw new Error("inputNameCompanyLength is greater than one");
                        }
                    }
                    // #endregion
                    // #region Special logic for putting first name and last name on the same row
                    const firstNameLastNameInputArray = $refCurrent
                        .find('input[name="FirstName"], input[name="LastName"]')
                        .toArray();
                    if (firstNameLastNameInputArray.length === 2) {
                        let isLeft = true;
                        for (const ht of firstNameLastNameInputArray) {
                            const $ht = $(ht);
                            const $mktoFormRow = $ht
                                .parents(".mktoFormRow")
                                .eq(0);
                            $mktoFormRow.addClass(cx(classCombiner(styles, "splitColumn"), classCombiner(styles, `isLeft-${isLeft}`)));
                            isLeft = false;
                        }
                    }
                    // #endregion
                    // #region Special logic for two-step layout
                    if (useTwoStepFormBoolean) {
                        $refCurrent
                            .find(".mktoButtonRow, .mktoFormRow")
                            .not($refCurrent
                            .find('input[name="Email"]')
                            .parents(".mktoFormRow")
                            .eq(0))
                            .addClass(cx(classCombiner(styles, "hideOnFirstStep")));
                    }
                    // #endregion
                }
            });
        });
    }, []);
    return _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "marketoFormWrapper"), classCombiner(styles, `isFirstStepActive-${isFirstStepActive}`), classCombiner(styles, `useTwoStepForm-${useTwoStepFormBoolean}`), "leadform-form", componentclass) }, { children: [isNotUndefinedOrNull(heading) && heading.length > 0
                ? _jsx("h2", { children: heading })
                : _jsx(_Fragment, {}), isNotUndefinedOrNull(formDescription) && formDescription.length > 0
                ? _jsx("p", { children: formDescription })
                : _jsx(_Fragment, {}), _jsx("form", { ref: reference }), useTwoStepFormBoolean && isFirstStepActive
                ?
                    _jsx("button", Object.assign({ className: cx(classCombiner(styles, "continueToSecondStepOfTwoStepFormButton")), onClick: () => setIsFirstStepActive(false), type: "button" }, { children: continueToSecondStepOfTwoStepFormButtonText }))
                :
                    _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "termsOfUsePrivacyPolicyWrapper"), "mktoHtmlText") }, { children: [isNotUndefinedOrNull(termsOfUseLink) && termsOfUseLink.length > 0
                                ? _jsx("a", Object.assign({ href: termsOfUseLink }, { children: termsOfUseText }))
                                : _jsx(_Fragment, {}), isNotUndefinedOrNull(termsOfUseLink) && termsOfUseLink.length > 0 && isNotUndefinedOrNull(privacyPolicyLink) && privacyPolicyLink.length > 0
                                ? _jsx("span", Object.assign({ className: cx(classCombiner(styles, "linkDivider")) }, { children: "|" }))
                                : _jsx(_Fragment, {}), isNotUndefinedOrNull(privacyPolicyLink) && privacyPolicyLink.length > 0
                                ? _jsx("a", Object.assign({ href: privacyPolicyLink }, { children: privacyPolicyText }))
                                : _jsx(_Fragment, {})] })), additionalText.length > 0
                ? _jsx("div", { className: cx(classCombiner(styles, "additionalText"), "mktoHtmlText"), dangerouslySetInnerHTML: { "__html": additionalText } })
                :
                    _jsx(_Fragment, {})] }));
};
const marketoForm = (renderableData) => renderIdentifierGeneric(MarketoFormComponent, renderableData);
export { marketoForm };
